const solutions = (n) => {
  if (n < 3) {
    return `
- Importo Annuale: Euro 790,00 + IVA 22% cadauno
- Importo Biennale: Euro 1.430,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.900,00 + IVA 22% cadauno
`
  } else if (n < 5) {
    return `
- Importo Annuale: Euro 770,00 + IVA 22% cadauno
- Importo Biennale: Euro 1.380,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.820,00 + IVA 22% cadauno
`
  } else if (n < 10) {
    return `
- Importo Annuale: Euro 720,00 + IVA 22% cadauno
- Importo Biennale: Euro 1.310,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.750,00 + IVA 22% cadauno
`
  } else if (n < 20) {
    return `
- Importo Annuale: Euro 680,00 + IVA 22% cadauno
- Importo Biennale: Euro 1.220,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.620,00 + IVA 22% cadauno
`
  } else {
    return `
- Importo Annuale: Euro 630,00 + IVA 22% cadauno
- Importo Biennale: Euro 1.150,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.520,00 + IVA 22% cadauno
`
  }
}

const extraOptions = (n) => {
  if (n < 3) {
    return `
Qualora lo desideri, può anche dilazionare la spesa in rate da 24 oppure 36 mesi tramite la formula del Noleggio Operativo e addebito tramite RID bancario:

- Importo Biennale: Euro 70,43 + IVA 22% al mese per 24 mesi (importo rateale di una singola licenza).
- Importo Triennale: Euro 66,83 + IVA 22% al mese per 36 mesi (importo rateale di una singola licenza).
`
  } else {
    return `
Qualora lo desideri, può anche dilazionare la spesa in rate da 24 oppure 36 mesi tramite la formula del Noleggio Operativo e addebito tramite RID bancario.
`
  }
}

const makeEmail = (contact, contracts, productContracts, moment, n) => {
  let contractsText = contracts.map((contract) => {
    let productContract
    if (contract.product_contract) {
      productContract = productContracts.find(function (c) {
        return contract.product_contract === c.id
      })
    } else {
      productContract = {
        amount: "x",
        serial: "x"
      }
    }

    return `Contratto ${contract.type_name} - Qtà: ${productContract.amount} – ${productContract.order}° Chiave Nr: ${productContract.serial}, in scadenza il giorno ${moment(contract.end_date).format("DD/MM/YYYY")}`
  }
  ).join("\n")

  let body = `
Gentile professionista,

vogliamo avvisare che i seguenti Contratti di Assistenza e Aggiornamento (C.d.A.A.) ARCHICAD a Lei intestati sono in scadenza:

${contractsText}

CONDIZIONI:	È possibile scegliere tra tre soluzioni di rinnovo del C.d.A.A.:

${solutions(n)}

Il listino completo è disponibile al seguente link: https://media.archicad.it/moduli/GS_tabella_aggiornamenti.pdf

RINNOVARE IL CONTRATTO DI ASSISTENZA E AGGIORNAMENTO SIGNIFICA MASSIMIZZARE LA PRODUTTIVITA’ E RIDURRE NEL TEMPO L’INVESTIMENTO SUL SOFTWARE.

Per rinnovare il C.d.A.A., le chiediamo cortesemente di rispondere alla presente indicando la durata del prossimo rinnovo (annuale, biennale o triennale) ENTRO IL XX/XX/XXXX.

La fattura verrà emessa da Graphisoft all’inizio di XXXXXX e il pagamento dovrà essere effettuato entro il XX/XX/XXXX con BONIFICO BANCARIO secondo le modalità indicate in fattura.
Se invece preferisce pagare con CARTA DI CREDITO, dovrà farlo presente rispondendo alla presente mail.
Se ha variato i dati di fatturazione, La preghiamo di comunicarceli contestualmente alla conferma del rinnovo del contratto.

${extraOptions(n)}

Se interessato al rinnovo mediante noleggio operativo, La preghiamo di darci conferma alla presente entro il XX/XX/XXXX. Le indicheremo i documenti da inviarci per poter attivare la pratica Grenke.

SERVIZI RISERVATI AGLI UTENTI IN CONTRATTO.
Le ricordiamo i vantaggi del contratto ed i servizi ARCHICLUB a lei riservati:
- Le nuove release di ARCHICAD saranno abilitate gratuitamente non appena disponibili.
- Assistenza tecnica telefonica gratuita dal lunedì al venerdì dalle 9:00 alle 13:00 e dalle 14:00 alle 18:00 via mail a: supportotecnico@graphisoft.com
- Sostituzione gratuita di chiavi danneggiate/guaste/furto/incendio.
- Sconti riservati per l’acquisto di prodotti GRAPHISOFT o di terze parti.
- Webinar dedicati all’approfondimento delle varie funzionalità di ARCHICAD.
- Video Tutorial, filmati brevi (10-15 minuti), per la condivisione di informazioni, funzioni,
suggerimenti, trucchi nell’uso dei software sviluppati e distribuiti da GRAPHISOFT
- Informazioni, istruzioni, condivisione di esperienze sull’ambiente BIM.
- Newsletter dedicata alle novità del mondo GRAPHISOFT.
- Per maggiori informazioni su ARCHICLUB: https://www.graphisoft.com/it/archiclub/

Qualora decidesse di non rinnovare il suo Contratto di Assistenza ed Aggiornamento, dovrà far pervenire eventuale disdetta tramite PEC (indicando la motivazione) a OPENVIEW SRL entro il XX/XX/XXXX al seguente indirizzo: openviewsrls@pec.it, onde evitare la tacita fatturazione del rinnovo del contratto annuale.

Prima di procedere con l’eventuale disdetta, le ricordiamo che i costi di riattivazione da corrispondere oltre al canone del contratto, sono i seguenti:
- Riattivazione (per utenti con la versione più aggiornata): € 400
- Upgrade 1 Step: € 1.300
- Upgrade 2 Step: € 2.600
- Upgrade 3+ Step: € 3.900

Ringraziandola per la fiducia sino ad ora accordata, restiamo a disposizione per ogni ulteriore informazione.
Cordiali saluti.

    `
  return body
}

export default makeEmail
